/**
 * TODO:
 *   1. this is not a pure component, but it's not like a container either.
 *      what a best way to categorize this?
 */
import { useUnit } from 'effector-react';
import { Route, RouteProps } from 'react-router-dom';

import { hasRoles } from '@m/services/keycloak/iamRoles';
import { RoleNameValue } from '@m/types/api/iam/Iam';
import { authStore } from 'apps/admin/state/auth';

export interface AuthenticatedRouteProps extends Omit<RouteProps, 'children'> {
  breadcrumb?: React.ComponentType | string | null;
  children?: React.ReactNode;
  roles?: RoleNameValue[];
}

export default function AuthenticatedRoute({ children, roles, ...props }: AuthenticatedRouteProps) {
  const { authenticated } = useUnit(authStore);

  // DO NOT redirect to /login when authentication status is undetermined
  if (authenticated === null || (roles && !hasRoles(roles))) {
    // or redirect to login??
    return null;
  }

  return <Route {...props} render={() => children} />;
}
